/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Card_ActionsInputs */

const cs_templates_card_actions = /** @type {(inputs: Templates_Card_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akce šablony`)
};

const en_templates_card_actions = /** @type {(inputs: Templates_Card_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Template actions`)
};

/**
* | output |
* | --- |
* | "Template actions" |
*
* @param {Templates_Card_ActionsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_card_actions = /** @type {((inputs?: Templates_Card_ActionsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Card_ActionsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_card_actions(inputs)
	return cs_templates_card_actions(inputs)
});